// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import "babel-polyfill"; //兼容
import Vue from "vue";
import App from "./App";
import ElementUI from "element-ui";
import "element-ui/lib/theme-chalk/index.css";
import router from "./router";
import pulgins from "./components/plugins/index";
import api from "./api/index";
import lazyload from "vue-lazyload";
import promise from "es6-promise";
promise.polyfill();

import store from "./store";
// import breadCrumb from './components/plugins/bread-crumb.vue'
import success from "./components/success.vue";
import error from "./components/error.vue";
Vue.component("success", success);
Vue.component("error", error);
// Vue.use(breadCrumb)
Vue.use(lazyload);
Vue.use(ElementUI);
Vue.use(pulgins);
Vue.prototype.$defaultImg = require("@/assets/images/defaultimg.png");
Vue.config.productionTip = false;
Vue.prototype.$api = api;
Vue.prototype.$store = store;
/* eslint-disable no-new */
new Vue({
  el: "#app",
  router,
  components: { App },
  template: "<App/>"
});



// WEBPACK FOOTER //
// ./src/main.js